/* SleepFit PDP (Little Bear layout) — bundle picker + add to cart. Their own inline scripts (gallery, FAQ, sticky, load more) stay in the section.
   Duo / Trio prices are charged by the "SleepFit bundle pricing" automatic discount (~/shopify-apps/needoh-box-pricing,
   extensions/sleepfit-pricing): it prices the lines carrying _sf_offer, grouped by _sf_id (one id per click). No code, no gift.
   CTAs below the offer (final CTA, sticky bar once past the offer) buy the selected pack and go straight to checkout. */
(function () {
  var root = document.querySelector('[data-lb]');
  if (!root) return;
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  var opts = $$('[data-lb-pack]');
  var pack = function () { var c = root.querySelector('[data-lb-packs] input:checked'); return c ? +c.value : 1; };
  var sync = function () { opts.forEach(function (o) { o.classList.toggle('is-active', o.querySelector('input').checked); }); };
  $$('[data-lb-packs] input').forEach(function (i) { i.addEventListener('change', sync); });
  window.addEventListener('pageshow', function () { sync(); var a = root.querySelector('[data-lb-atc]'); if (a) a.disabled = false; });
  sync();

  var base = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
  var json = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var items = function () {
    var n = pack(), by = {}, bid = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    var opt = root.querySelector('[data-lb-pack="' + n + '"]');
    $$('select[data-lb-size]', opt).forEach(function (s) { by[s.value] = (by[s.value] || 0) + 1; });
    return Object.keys(by).map(function (id) { return { id: +id, quantity: by[id], properties: { _sf_offer: '1', _sf_id: bid } }; });
  };
  var buy = function () {
    var btn = root.querySelector('[data-lb-atc]'), err = root.querySelector('[data-lb-err]');
    btn.disabled = true; err.hidden = true;
    var ours = {}; $$('select[data-lb-size] option').forEach(function (o) { ours[o.value] = 1; });
    fetch(base + 'cart.js', { headers: json }).then(function (r) { return r.json(); })
      .then(function (cart) {
        var reset = {};
        cart.items.forEach(function (it) { if (ours[it.variant_id]) reset[it.key] = 0; });
        return Object.keys(reset).length ? fetch(base + 'cart/update.js', { method: 'POST', headers: json, body: JSON.stringify({ updates: reset }) }) : null;
      })
      .then(function () { return fetch(base + 'cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: items() }) }); })
      .then(function (r) {
        if (!r.ok) throw r;
        return fetch(base + 'cart/update.js', { method: 'POST', headers: json, body: JSON.stringify({ attributes: { 'Free gifts': '' } }) });
      })
      .then(function () { window.location.href = root.dataset.go === 'cart' ? '/cart' : '/checkout'; })
      .catch(function () {
        btn.disabled = false; err.textContent = 'Sorry, that size is unavailable right now. Please choose another.'; err.hidden = false;
        document.getElementById('offer').scrollIntoView({ behavior: 'smooth' });
      });
  };
  var form = root.querySelector('[data-lb-form]');
  if (form) form.addEventListener('submit', function (e) { e.preventDefault(); buy(); });

  // capture phase: runs before the sticky button's inline scroll handler
  window.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.final-cta .btn-primary, .sticky-cta-btn');
    if (!t || !form) return;
    if (t.classList.contains('sticky-cta-btn') && form.getBoundingClientRect().bottom > 0) return;
    e.preventDefault(); e.stopPropagation(); buy();
  }, true);
})();
